import { useQuery } from "@tanstack/react-query";
import { dashboardApi } from "@/api/dashboard.api";
import { queryKeys } from "@/utils/queryKeys";

/** GET /admin/dashboard — refetched every 30s to keep the ops view live. */
export function useDashboardOverview() {
  return useQuery({
    queryKey: queryKeys.dashboard.stats(),
    queryFn: () => dashboardApi.getOverview(),
    refetchInterval: 30_000,
  });
}

/** GET /admin/reports?from&to — period KPIs, ride/GMV trend, and top zones. */
export function useAdminReport(params?: { from?: string; to?: string }) {
  return useQuery({
    queryKey: queryKeys.dashboard.report(params),
    queryFn: () => dashboardApi.getReport(params),
  });
}
